define([
    "csi/access/_base",
    "csi/access/access",
    "csi/access/full",
    "csi/access/readOnly"
], function(csiAccess,access,full,readOnly) {

// add view security configuration

	var sourcingAdminRoles = ['Sourcing Admin'];
	var sourcingEditRoles = sourcingAdminRoles.concat(['Sourcing Editor']);

	csiAccess.addViewRoles({
		"ProductSourcing":{
			"BlendedCostScenarios":{
				"Copy":access(full(sourcingEditRoles)),
				"Delete":access(full(sourcingEditRoles)),
				"NewCostScenarioBlended":access(full(sourcingEditRoles))
			},
			"CostScenarios":{
				"Copy":access(full(sourcingEditRoles)),
				"Delete":access(full(sourcingEditRoles)),
				"NewCostScenario":access(full(sourcingEditRoles))
			}
		}
	});
});